app.controller('CommonModalSimpleController',
    ['$rootScope', '$scope', '$state', 'items', '$location',
        function ($rootScope, $scope, $state, items, $location) {

            $scope.notice_txt = items.notice_txt;
            $scope.paragraph_txt = items.paragraph_txt;
            $scope.sref = items.sref;
            $scope.params = items.params;
            $scope.cancel_callback = items.cancel_callback;
            $scope.callback = items.callback;
            $scope.hide_close = items.hide_close;
            $scope.close_txt = items.close_txt;
            $scope.ok_txt = items.ok_txt;
            $scope.href = items.href;
            $scope.items = items;

            $scope.ok = function () {
                if ($scope.callback) {
                    $scope.callback($scope.params);
                }
                if ($scope.href) {
                    $location.url($scope.href);
                } else if ($scope.sref) {
                    $state.go($scope.sref, $scope.params);
                }
                $scope.$close();
            }

            $scope.cancel = function () {
                if ($scope.cancel_callback) {
                    $scope.cancel_callback($scope.params);
                }
                $scope.$close();
            };

        }]);